const { useCallback } = require('react')
const { decodeFunctionData } = require('viem')

export const useDecodeFunctionInput = () => {
    const getDecodeInput = useCallback((abi, data) => {
        try {
            if (!abi || !data) return []

            let parsedAbi = abi
            if (!Array.isArray(parsedAbi)) {
                parsedAbi = [parsedAbi]
            }

            if (parsedAbi.length === 0) return []

            const decoded = decodeFunctionData({
                abi: parsedAbi,
                data: data
            })

            if (!decoded) return []

            return decoded.args.map((value, index) => ({
                index: index,
                name: abi.inputs[index].name,
                type: abi.inputs[index].type,
                value: value.toString()
            }))
        } catch (error) {
            console.error('Error decoding function data:', error)
            return []
        }
    }, [])

    return {
        getDecodeInput
    }
}
